import { BracketMatch } from "model/Bracket/BracketMatch";
import { nonUndefined } from "Utility";
import { mapTeamSources } from "./FsTeamSource";
import { FsBracketMatch } from "db/model/tournament/Segment/Bracket/FsBracketMatch";

export const mapBracketMatchs = (
  fsModels: FsBracketMatch[]
): BracketMatch[] => {
  return nonUndefined(fsModels.map(mapBracketMatch));
};

const mapBracketMatch = (fsModel: FsBracketMatch): BracketMatch | undefined => {
  if (
    !fsModel.matchId ||
    ((!fsModel.teamOneSource || !fsModel.teamTwoSource) && !fsModel.teamSources)
  ) {
    return undefined;
  }

  const teamSources = mapTeamSources(nonUndefined(fsModel.teamSources ?? []));
  return {
    isFinal: fsModel.isFinal ?? false,
    isUpperFinal: fsModel.isUpperFinal ?? false,
    matchId: fsModel.matchId,
    resetMatchId: fsModel.resetMatchId,
    teamOneSource: fsModel.teamOneSource ?? "",
    teamTwoSource: fsModel.teamTwoSource ?? "",
    teamSources,
  };
};
